import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import store from '../../redux/store';
import { get_tutorial_data } from '../../redux/Slice/TutorialSlice';
import {
  CardLayout,
  DashboardContainer,
} from '../../components/ui/UtilsLayout';
import Input from '../../components/ui/Input';
import { iconsPath } from '../../utils/imagePath';

const Tutorial = () => {
  const tutorialState = useSelector((state) => state.tutorial) || {};
  const {
    tutorial_data = [],
    tutorial_loading = false,
    tutorial_error = null,
  } = tutorialState;
  const { category } = useParams(); // Get category from URL params

  // Map URL category to API category
  const getApiCategory = (urlCategory) => {
    const categories = [
      { url: 'getting_started', api: 'Getting Started' },
      { url: 'interactive_3d', api: 'Interactive 3D' },
      { url: 'surface_tracking', api: 'Surface Tracking' },
      { url: 'image_tracking', api: 'Image Tracking' },
      { url: 'location_tracking', api: 'Location Tracking' },
      { url: 'area_tracking', api: 'Area Tracking' },
      { url: 'virtual_spaces', api: 'Virtual Spaces' },
      { url: 'vr_training', api: 'VR Training' },
    ];
    const found = categories.find((cat) => cat.url === urlCategory);
    return found ? found.url : 'getting_started'; // Return URL category for dispatch
  };

  // Fetch tutorial data when category changes
  useEffect(() => {
    const dispatchCategory = getApiCategory(category);
    store.dispatch(get_tutorial_data(dispatchCategory));
  }, [category]);

  return (
    <DashboardContainer>
      {/* Header Section */}
      <div className="flex flex-row justify-between items-center">
        <div>
          <h1 className="text-md md:text-xl font-semibold">Getting Started</h1>
          <p className="text-[#BCBCBC]">Let's begin with some basics.</p>
        </div>

        {/* Search Input Field */}
        <div className="flex items-center gap-2">
          <Input
            leftIcon={
              <img
                className="absolute left-3 top-1/2 transform -translate-y-1/2 h-3 w-3"
                src={iconsPath?.group98Image}
                alt="Search icon"
                loading="lazy"
              />
            }
            type="text"
            placeholder={
              window.innerWidth > 500
                ? 'Search for any assets, templates, or files'
                : 'Search...'
            }
            className="bg-[#444447] text-white text-xs border border-[#5C5C5C] rounded-full w-36 md:w-64 px-10 py-1 shadow-md focus:outline-none focus:ring-2 focus:ring-gray-500 placeholder:text-[#B8B8B8]"
          />
        </div>
      </div>

      {/* Loading and Error States */}
      {tutorial_loading && <p>Loading tutorials...</p>}
      {tutorial_error && (
        <p className="text-red-500">{String(tutorial_error)}</p>
      )}

      {/* Tutorial Data Display */}
      {tutorial_data?.length > 0 && (
        <CardLayout
          subName="description"
          gridClass="grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-2 xl:grid-cols-3"
          showName="title"
          cards={tutorial_data[0]?.data}
        />
      )}
    </DashboardContainer>
  );
};

export default Tutorial;
